import * as t from 'io-ts';

export const ConstraintViolationCodec = t.partial({
    field: t.string,
    message: t.string,
});

export const ProblemCodec = t.partial({
    type: t.string,
    title: t.string,
    status: t.number,
    detail: t.string,
    instance: t.string,
});

export const ProblemWithDetailCodec = t.intersection([
    ProblemCodec,
    t.type({
        detail: t.string,
    }),
]);

export const ProblemWithConstraintViolationCodec = t.intersection([
    ProblemCodec,
    t.type({
        violations: t.array(ConstraintViolationCodec),
    }),
]);

export const ProblemWithErrorCodeCodec = t.intersection([
    ProblemCodec,
    t.type({
        error_code: t.string,
    }),
]);

export const ExportTooLargeProblemCodec = t.intersection([
    ProblemWithErrorCodeCodec,
    t.type({
        error_code: t.literal('result-set-too-large'),
    }),
]);

export type Problem = t.TypeOf<typeof ProblemCodec>;
export type ProblemWithConstraintViolation = t.TypeOf<typeof ProblemWithConstraintViolationCodec>;
